import React, { FC } from 'react';

import i18n from '@yandex-int/i18n';
import { ErrorBoundary } from 'client/blocks/ErrorBoundary/ErrorBoundary';
import { AliceAgentAppDTO } from 'client/model/aliceAgentApp';
import * as keyset from 'i18n/AliceAgentAppAccess';

import { AliceAgentAppGenerateLinkSection } from './AliceAgentAppGenerateLinkSection';
import styles from './AliceAgentAppSharingPage.module.scss';
import { AliceAgentAppUsersListSection } from './AliceAgentAppUsersListSection';

const t = i18n(keyset);

interface Props {
    app: AliceAgentAppDTO;
}

export const AliceAgentAppSharingPage: FC<Props> = ({ app }) => {
    return (
        <ErrorBoundary withHomepageLink>
            <div className={styles.page}>
                <h2 className={styles.pageHeader}>{t('header')}</h2>
                {app.onAir && <AliceAgentAppGenerateLinkSection app={app} />}
                <AliceAgentAppUsersListSection app={app} />
            </div>
        </ErrorBoundary>
    );
};
